/* eslint-disable */
import {
  Conf
} from '../conf/defaults'
import axios from 'axios'

// Gestiche i tipi documento e stampanti
// I tipi documento sono definiti staticamente nel codice

//Fare una tabella in ARCAWS dove scrivere
//tipoDoc (campo libero)
//tipoStampa (A per automatica M per manuale)
//dispositivoDiStampa (name della Printer)
/*
CREATE TABLE ARCAWS.dbo.PrintConfig(
  TipoDoc varchar(100) NULL,
  TipoStampa varchar(20) NULL,
  DispositivoDiStampa varchar(255) NULL
) GO
*/

// tabella con i job di stampa **PrintJob**
/*
    Printer printer
    String jasperServerPathReport
    int jasperRECORD_ID;
    String state; //new, senttoclient, expired, queue, done, error
    byte[] data
*/

// una tabella con le stampanti **Printer** (che poi avranno il match con i medoti di stampa automatica)
/*  
    String name;
    Computer computer;
    String description;
    String capabilities;
    String isdefault;
    Date createTimestamp;
    String state;
*/

// una tabella dei dispositivi di stampa **Computer**
/*
    String name;
    String description;
    String inet;
    String hostname;
    String version;
    Date createTimestamp;
    String state;
    String KEY;
*/

export default {
  namespaced: true,
  state: {
    configStampaFieldTypes: [{
        "name": "PrintConfig_id",
        "type": "n"
      }, {
        "name": "TipoDoc",
        "type": "s"
      },
      {
        "name": "TipoStampa",
        "type": "s"
      },
      {
        "name": "DispositivoDiStampa",
        "type": "s"
      }
    ]
  },
  mutations: {},
  actions: {
   
  },
  getters: {}
}
